// extracted by mini-css-extract-plugin
module.exports = {"table-container":"LateOrders_table-container__3hYMZ","table":"LateOrders_table__1gFnl"};